import { render, staticRenderFns } from "./HomeIndicator.vue?vue&type=template&id=ed47b9c0&"
import script from "./HomeIndicator.vue?vue&type=script&lang=js&"
export * from "./HomeIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports